import BottomSheetModal from "components/BottomSheetModalType";
import React, { useCallback, useContext, useMemo, useState } from "react";
import {
  WalletBSWrapper,
  VerifyOtpButton,
  VerifyOtpInput,
  FlexDiv,
  OverlayWrapLayout,
  IconWrapLayout,
} from "../assets/style";
import { FilledButtonV1 } from "components/Buttons/FilledButtonV1";
import { AnchorWrapper } from "components/EslintCompatible";
import OTPInput from "components/OTPInput";
import { DownCounter } from "components/Counter";
import FeedbackBar from "components/FeedbackBar";
import { VerifyOtpContext } from "wrapper/VerifyOtpWrapper/context";
// import { W_OTP_VERIFIED } from "constants/cookies";
import { ApplicationContext } from "wrapper/ApplicationWrapper/context";
import { Overlay } from "@nykaa/payment-ui/src/Overlay";
import { useTheme } from "emotion-theming";
import { Icon } from "@nykaa/payment-ui/src/Icon";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import { getPlatform } from "../../../helpers";
import { DEVICE_TYPE } from "constants/index";
import { isServer } from "helpers/utils/isServer";


const SNACKBAR_ID = "verify-otp";

/**
 * @description
 * verify otp sheet with inputs and proceed button
 */
export const VerifyOTPSheet = ({
  closeVerifyOTPSheet,
  mobileNumber,
  verifyOtpCallback,
  otpDetails,
  setIsResendOtpClicked,
  isResendOtpClicked,
}: VerifyOTPSheetProps) => {
  const [submitToVerifyOTP, setSubmitToVerifyOTP] = useState(false);
  const [otp, setOtp] = useState("");
  // state for timer visible
  const [isTimerVisible, setIsTimerVisible] = useState(isResendOtpClicked);
  const { otp_length } = otpDetails;
  const { applicationData } = useContext(ApplicationContext);
  const { deviceType } = applicationData;
  const theme: any = useTheme();
  const platform = getPlatform();

  const {
    showSnackBar,
    setSnackBar,
    snackBarMsg,
    apiSuccess,
    setIsVerifyOtpVisible,
    verificationSuccess,
    setIsOtpVerificationRequired,
  } = useContext(VerifyOtpContext);

  useMemo(() => {
    if (otp_length && otp_length === otp.length) {
      setSubmitToVerifyOTP(true);
    } else if (submitToVerifyOTP) {
      setSubmitToVerifyOTP(false);
    }
  }, [otp, otp_length, submitToVerifyOTP]);

  // handling of visibility of timer
  useMemo(() => {
    if (isResendOtpClicked) {
      setIsTimerVisible(true);
    } else if (isTimerVisible) {
      setIsTimerVisible(false);
    }
  }, [isResendOtpClicked, isTimerVisible]);

  // handling verify otp proceed click
  const handleVerifyOTPClick = useCallback(() => {
    if (submitToVerifyOTP) {
      verifyOtpCallback(otp);
    }
  }, [submitToVerifyOTP, verifyOtpCallback, otp]);

  // toggle of resend otp click
  const toggleResendOtpClick = () => {
    setIsResendOtpClicked(!isResendOtpClicked);
  };

  const common = () => (
    <>
      <div className={`layout vertical ${deviceType === DEVICE_TYPE.MOBILE && "flex-1"}`}>
        <p className="mt10">
          To use your wallet, kindly verify your mobile number&nbsp;
          <AnchorWrapper className="text-primary">+91-{mobileNumber}</AnchorWrapper>
        </p>
        <VerifyOtpInput>
          {/* eslint-disable jsx-a11y/no-autofocus */}
          <OTPInput
              autoFocus
              isNumberInput
              length={6}
              className="otpContainer"
              inputClassName="otpInput"
              onChangeOTP={currentOtp => setOtp(currentOtp)}
              placeholder=""
            />
        </VerifyOtpInput>
      </div>
      <FlexDiv
          className={`mt10 ${isResendOtpClicked ? "disabled" : ""}`}
          onClick={toggleResendOtpClick}
        >
        Resend OTP&nbsp;
        {isResendOtpClicked && (
        <FlexDiv className="disabled">
          in 00:
          <DownCounter
                initialTimerValue={45}
                finalTimerValue={0}
                callback={toggleResendOtpClick}
              />
        </FlexDiv>
          )}
      </FlexDiv>
      <VerifyOtpButton className="pos-fixed background p15">
        <FilledButtonV1
            className={`width-full p15 ${submitToVerifyOTP ? "" : "disabled"}`}
            type="submit"
            onClick={handleVerifyOTPClick}
          >
          <span>Confirm OTP</span>
        </FilledButtonV1>
      </VerifyOtpButton>
    </>
    );

  const DesktopView = () => (
    <Overlay theme={theme}>
      <OverlayWrapLayout>
        <IconWrapLayout>
          <Icon icon={getIcons(platform, ICONS_NAMES.CLEAR)} onClick={closeVerifyOTPSheet} theme={theme} />
        </IconWrapLayout>
        {common()}
      </OverlayWrapLayout>
    </Overlay>
    );

  const MobileView = () => (
    <BottomSheetModal
        extraClass="verify-otp-bs"
        bodyClass="vertical prl15"
        pageTitle="Verify Wallet"
        closeBottomSheetModal={closeVerifyOTPSheet}
        zIndex={3}
      >
      {common()}
    </BottomSheetModal>
    );

  return (
    <WalletBSWrapper>
      {deviceType === DEVICE_TYPE.DESKTOP ? DesktopView() : MobileView()}
      {showSnackBar && (
        <FeedbackBar
          autoClose
          errorCloseCallback={() => {
            setSnackBar(false);
          }}
          successCloseCallback={() => {
            setSnackBar(false);
            if (verificationSuccess && !isServer()) {
              // sessionStorage.setItem(W_OTP_VERIFIED, "1");
              setIsVerifyOtpVisible(false);
              setIsOtpVerificationRequired(false); // setting otp verification to false after successful verification
            }
          }}
          content={snackBarMsg}
          errorType={apiSuccess ? false : true}
          feedbackBarId={SNACKBAR_ID}
        />
      )}
    </WalletBSWrapper>
  );
};
